import React from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { checkOptionDisabled } from 'modules/settings/workflow_automation/helpers/automationCommonHelpers';

function PrimeReactMultiSelect(props) {
  const { value = [], name = '', options = [], isFilter = false, onChange = (e) => {}, optionDisabled = [], ...rest } = props || {};
  return (
    <MultiSelect
      value={options?.length > 0 ? value : []} //This conditionn is applied to avoid empty "chip" in all multiselectbox with property display="chip"
      name={name}
      options={options}
      onChange={(e) => {
        onChange(e);
      }}
      filter={isFilter}
      filterPlaceholder="Search"
      resetFilterOnHide={true} //clearing search keyword on hide
      maxSelectedLabels={2}
      optionDisabled={checkOptionDisabled}
      {...rest}
    />
  );
}

export default PrimeReactMultiSelect;
